import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useEntityStore } from '../../../common/composables/entityStore';
import type { MappingTrace } from '../domain/mappingTrace';

export const useMappingTraceStore = defineStore('mapping-traces', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } = useEntityStore<MappingTrace>({
    eventName: 'mapping-trace-changed',
    getEntityId(entity) {
      return entity.id;
    },
    updateEntity(dest, src) {
      dest.createdAtUtc = src.createdAtUtc;
      dest.sourceImportRowId = src.sourceImportRowId;
      dest.sourceProductName = src.sourceProductName;
      dest.sourceProductGroupName = src.sourceProductGroupName;
      dest.sourceCode = src.sourceCode;
      dest.sourceWidth = src.sourceWidth;
      dest.sourceHeight = src.sourceHeight;
      dest.sourceLength = src.sourceLength;
      dest.sourceMoisture = src.sourceMoisture;
      dest.matchedProfileId = src.matchedProfileId;
      dest.matchedProfileName = src.matchedProfileName;
      dest.matchedPriority = src.matchedPriority;
      dest.resolvedProductId = src.resolvedProductId;
      dest.resolvedProductName = src.resolvedProductName;
      dest.resolvedPackageTypeId = src.resolvedPackageTypeId;
      dest.resolvedPackageTypeName = src.resolvedPackageTypeName;
      dest.resolvedPackagingId = src.resolvedPackagingId;
      dest.resolvedPackagingName = src.resolvedPackagingName;
      dest.correctedAtUtc = src.correctedAtUtc;
      dest.correctedBy = src.correctedBy;
      dest.correctionNote = src.correctionNote;
      dest.revision = src.revision;
    },
  });

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    mappingTraces: list,
    sortedByNewest: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => b.createdAtUtc.localeCompare(a.createdAtUtc));
      return clone;
    }),
  };
});
